import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CommonService } from 'src/app/services/common/common.service'
import { DynamicComponentLoaderService } from 'src/app/services/component-loader/dynamic-component-loader.service'
import { LoginService } from 'src/app/services/login/login.service'
import { passwordMatchValidator, passwordValidator } from 'src/app/validators/validators.validator'

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  @ViewChild('selectpg-popup', { static: true }) selectPgPopup: ElementRef

  selectpgPopup: any
  resetPasswordWithExistingPasswordForm: FormGroup

  readonly NEW_PASSWORD = 'newPassword'

  readonly CONFIRM_PASSWORD = 'confirmPassword'

  constructor(
    private cs: CommonService,
    private loginService: LoginService,
    private elementRef: ElementRef,
    private formBuilder: FormBuilder,
    private dynamicComponentLoaderService: DynamicComponentLoaderService
  ) {}

  ngOnInit(): void {
    this.selectpgPopup = this.elementRef.nativeElement.querySelector('#selectpg-popup')
    this.selectpgPopup.style.display = 'block'
    this.buildResetPasswordWithExistingPasswordForm()
  }

  updatePassword() {
    const form = this.resetPasswordWithExistingPasswordForm
    if (form.invalid) {
      return this.cs.showError('Invalid Inputs')
    }
    if (form.value.newPassword !== form.value.confirmPassword) {
      this.cs.showError('New Password and Confirm Password should be same')
      return
    }
    const formValue = { ...form.value }
    this.loginService.dispatchResetPasswordWithOldPasswordAction(
      formValue.oldPassword,
      formValue.newPassword,
      this.exit()
    )
  }

  exit() {
    const dynamicComponentLoaderService = this.dynamicComponentLoaderService

    return function closeModel() {
      dynamicComponentLoaderService.closeComponent(GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.key)
    }
  }

  buildResetPasswordWithExistingPasswordForm() {
    this.resetPasswordWithExistingPasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      [this.NEW_PASSWORD]: ['', [Validators.required, passwordValidator()]],
      [this.CONFIRM_PASSWORD]: [
        '',
        [Validators.required, passwordMatchValidator(this.NEW_PASSWORD, this.CONFIRM_PASSWORD)]
      ]
    })
  }

  get f() {
    return this.resetPasswordWithExistingPasswordForm.controls
  }

  handleNewPasswordChange(password: any) {
    this.resetPasswordWithExistingPasswordForm.controls[this.NEW_PASSWORD].setValue(password)
    this.resetPasswordWithExistingPasswordForm.controls[this.NEW_PASSWORD].markAsTouched()
  }

  handleConfirmPasswordChange(password: any) {
    this.resetPasswordWithExistingPasswordForm.controls[this.CONFIRM_PASSWORD].setValue(password)
    this.resetPasswordWithExistingPasswordForm.controls[this.CONFIRM_PASSWORD].markAsTouched()
  }
}
